import {isEmpty, isNil, uniq} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Photos the gallery shows: the listing's gallery without photos that failed to load, and the
 * listing thumbnail when the gallery is empty or none of its photos loaded.
 */
export const getGalleryImages = (
  pictureUrls: string[],
  thumbnailUrl: string | Nullish,
  failedUrls: string[]
) => {
  const loadable = (urls: string[]) => uniq(urls).filter((url) => !failedUrls.includes(url));
  const gallery = loadable(pictureUrls);

  if (!isEmpty(gallery) || isNil(thumbnailUrl) || isEmpty(thumbnailUrl)) {
    return gallery;
  }

  return loadable([thumbnailUrl]);
};
